import { render, staticRenderFns } from "./ReferralDetails.vue?vue&type=template&id=55b86ecf&scoped=true"
import script from "./ReferralDetails.vue?vue&type=script&lang=js"
export * from "./ReferralDetails.vue?vue&type=script&lang=js"
import style0 from "./ReferralDetails.vue?vue&type=style&index=0&id=55b86ecf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b86ecf",
  null
  
)

export default component.exports